import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'xrm-confirmation-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class XRMConfirmDialogComponent implements OnInit {
  public confirmMessage: string;
  public extraMessage: string;
  public confirmButtonText = 'Confirm';
  public cancelButtonText = 'Cancel';
  public confirmHeader = 'confirm';
  public showCancelButton = true;

  constructor(public dialogRef: MatDialogRef<XRMConfirmDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    if (data) {
      this.confirmMessage = data.confirmMessage ? data.confirmMessage : this.confirmMessage;
      this.confirmButtonText = data.confirmButtonText ? data.confirmButtonText : this.confirmButtonText;
      this.cancelButtonText = data.cancelButtonText ? data.cancelButtonText : this.cancelButtonText;
      this.confirmHeader = data.confirmHeader ? data.confirmHeader : this.confirmHeader;
      this.showCancelButton = data.showCancelButton !== undefined ? data.showCancelButton : this.showCancelButton;
    }
  }

  ngOnInit() {}
}
